// Copyright (c) 2022 by Move Closer

import { CategoryData, IRelatedService, ModuleContentResolver } from '../../contexts'
import { logger } from '../../support'

import { BrandData, BrandTeaserModuleContent, BrandTeaserModuleContentInput } from './BrandTeaser.contracts'
import { resolveCategory } from '../resolvers'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const resolveBrandTeaserModuleContent: ModuleContentResolver<BrandTeaserModuleContentInput, BrandTeaserModuleContent> =
  async (input: BrandTeaserModuleContentInput, relatedService: IRelatedService): Promise<BrandTeaserModuleContent> => {
    let brands: BrandData[] = []

    try {
      brands = await Promise.all(input.brands.map(async ({
        category,
        ...rest
      }) => {
        let resolvedCategory: CategoryData | null = null

        if (category) {
          resolvedCategory = await resolveCategory(category, relatedService)
        }

        return {
          category: resolvedCategory,
          ...rest
        }
      }))
    } catch (e) {
      logger(e, 'warn')
    }

    return {
      ...input,
      brands
    }
  }
